import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { IAppState } from '../app.state';
import { Store } from '@ngrx/store';
import { Router } from '@angular/router';
import { MailingsService } from '@services/mailngs/mailings.service';
import {
  CreateMailing,
  CreateMailingFailure,
  CreateMailingSuccess,
  EMailingsActions,
  GetMailing,
  GetMailingFailure,
  GetMailings,
  GetMailingsFailure,
  GetMailingsSuccess,
  GetMailingSuccess,
  GetResults,
  GetResultsFailure,
  GetResultsSuccess,
  UpdateMailing,
  UpdateMailingFailure,
  UpdateMailingSuccess,
} from './mailings.actions';
import { ToastrService } from 'ngx-toastr';

@Injectable()
export class MailingsEffects {
  constructor(
    private _actions$: Actions,
    private _store: Store<IAppState>,
    private _mailingsService: MailingsService,
    private _router: Router,
    private _toast: ToastrService
  ) {}

  $createMailing = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<CreateMailing>(EMailingsActions.CreateMailing),
        switchMap(action => {
          return this._mailingsService
            .createMailing({
              mailing: action.mailing,
              type: action.messageType,
            })
            .pipe(
              map(mailing => {
                this._store.dispatch(new CreateMailingSuccess(mailing));
                this._toast.success('Рассылка успешно создана');
                this._router.navigate([`/sending-messages/${mailing.id}`]);
              }),
              catchError(err => {
                this._toast.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При создании рассылки возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new CreateMailingFailure(err.error));
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $getMailings = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetMailings>(EMailingsActions.GetMailings),
        switchMap(() => {
          return this._mailingsService.getMailings().pipe(
            map(mailings => {
              this._store.dispatch(new GetMailingsSuccess(mailings));
            }),
            catchError(err => {
              this._toast.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'Не удалось получить список рассылок'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              this._store.dispatch(new GetMailingsFailure());
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $getMailing = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetMailing>(EMailingsActions.GetMailing),
        switchMap(action => {
          return this._mailingsService.getMailing(action.id).pipe(
            map(mailing => {
              this._store.dispatch(new GetMailingSuccess(mailing));
              this._store.dispatch(new GetResults(mailing.id));
            }),
            catchError(err => {
              this._store.dispatch(new GetMailingFailure());
              this._toast.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'Не удалось получить информацию о рассылке'
                }`,
                'Что-то пошло не так',
                { timeOut: 3500 }
              );
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );

  $updateMailing = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<UpdateMailing>(EMailingsActions.UpdateMailing),
        switchMap(action => {
          return this._mailingsService
            .updateMailing(action.mailing_id, action.data)
            .pipe(
              map(() => {
                this._store.dispatch(
                  new UpdateMailingSuccess(action.mailing_id, action.data)
                );
                this._router.navigate([
                  `/sending-messages/telegram/${action.mailing_id}`,
                ]);
                this._toast.success('Оповещение успешно отредактировано');
              }),
              catchError(err => {
                this._toast.error(
                  `${
                    err?.error?.detail
                      ? err?.error?.detail
                      : 'При редактировании оповещения возникла ошибка'
                  }`,
                  'Что-то пошло не так',
                  {
                    timeOut: 3500,
                  }
                );
                this._store.dispatch(new UpdateMailingFailure(err.error));
                return err.error;
              })
            );
        })
      );
    },
    { dispatch: false }
  );

  $getResults = createEffect(
    () => {
      return this._actions$.pipe(
        ofType<GetResults>(EMailingsActions.GetResults),
        switchMap(action => {
          return this._mailingsService.getResults(action.id).pipe(
            map(results => {
              this._store.dispatch(new GetResultsSuccess(results));
            }),
            catchError(err => {
              this._toast.error(
                `${
                  err?.error?.detail
                    ? err?.error?.detail
                    : 'Не удалось получить отчеты по рассылке'
                }`,
                'Что-то пошло не так',
                {
                  timeOut: 3500,
                }
              );
              this._store.dispatch(new GetResultsFailure());
              return err.error;
            })
          );
        })
      );
    },
    { dispatch: false }
  );
}
